import { render, staticRenderFns } from "./HeaderImgYjj.vue?vue&type=template&id=727aba27&scoped=true&"
import script from "./HeaderImgYjj.vue?vue&type=script&lang=js&"
export * from "./HeaderImgYjj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727aba27",
  null
  
)

export default component.exports